export const AUTH = {
  loginPhoneInput: 'login-phone-input',
  loginPasswordInput: 'login-password-input',
  loginSubmitButton: 'login-submit-button',
  loginError: 'login-error',
};

export const NAV = {
  sidebar: 'admin-sidebar',
  sidebarToggle: 'sidebar-toggle',
  navDashboard: 'nav-dashboard',
  navBilling: 'nav-billing',
  navInventory: 'nav-inventory',
  navCustomers: 'nav-customers',
  navDoctors: 'nav-doctors',
  navKhata: 'nav-khata',
  navPassbook: 'nav-passbook',
  navReports: 'nav-reports',
  navUsers: 'nav-users',
  navLogout: 'nav-logout',
  userInfo: 'user-info',
};

export const DASHBOARD = {
  container: 'dashboard-container',
  totalSales: 'stat-total-sales',
  totalRevenue: 'stat-total-revenue',
  totalMedicines: 'stat-total-medicines',
  totalCustomers: 'stat-total-customers',
  lowStock: 'stat-low-stock',
  salesChart: 'sales-chart',
};

export const BILLING = {
  container: 'billing-container',
  newSaleBtn: 'new-sale-button',
  billDate: 'bill-date-input',
  customerSearch: 'customer-search',
  doctorSearch: 'doctor-search',
  medicineSearch: 'medicine-search-input',
  productGrid: 'product-grid',
  paymentMode: 'payment-mode-select',
  saveSaleBtn: 'save-sale-button',
  savePrintBtn: 'save-print-button',
  saleTotal: 'sale-total',
  salesList: 'sales-list',
};

export const INVENTORY = {
  container: 'inventory-container',
  searchInput: 'inventory-search',
  addMedicineBtn: 'add-medicine-button',
  medicineTable: 'medicine-table',
  categoryFilter: 'category-filter',
};

export const CRM = {
  container: 'crm-container',
  searchInput: 'customer-search-input',
  addCustomerBtn: 'add-customer-button',
  customerTable: 'customer-table',
  typeFilter: 'customer-type-filter',
};

export const DOCTORS = {
  container: 'doctors-container',
  searchInput: 'doctor-search-input',
  addDoctorBtn: 'add-doctor-button',
  doctorTable: 'doctor-table',
};

export const MR_NAV = {
  bottomNav: 'mr-bottom-nav',
  navHome: 'mr-nav-home',
  navBeatPlan: 'mr-nav-beat-plan',
  navKhata: 'mr-nav-khata',
  navProfile: 'mr-nav-profile',
};

export const MR_HOME = {
  container: 'mr-home-container',
  attendanceCard: 'mr-attendance-card',
  markAttendanceBtn: 'mark-attendance-button',
};

export const MR_BEAT = {
  container: 'mr-beat-container',
  todayRoute: 'today-route',
  visitCard: 'visit-card',
  logVisitBtn: 'log-visit-button',
};

export const HOME = {
  emergentLink: 'emergent-link',
};
